
const proxy_route = 'vaults'
const api_route = 'api/v1/tenant_accounts'

// Define const Getters
const json_collection = state => state.json_collection
const meta_collection = state => state.meta_collection
const json_element = state => state.json_element
const meta_element = state => state.meta_element

const tenant_accounts = {
  namespaced: true,
  state: {
    json_collection: { data: [] },
    meta_collection: {},
    json_element: {},
    meta_element: {}
  },
  mutations: {
    store_collection (state, payload) {
      state.json_collection = payload.data
      state.meta_collection = payload.meta
    },
    store_element (state, payload) {
      state.json_element = payload.data
      state.meta_element = payload.meta
    },
    add_element (state, payload) {
      state.json_collection.data.push(payload)
    },
    update_element (state, payload) {
      state.json_collection.data[state.json_collection.data.findIndex( e=> e.id === payload.id)] = payload
    },
    remove_element (state, id) {
      state.json_collection.data.splice(state.json_collection.data.findIndex(e => e.id === id), 1)
    }
  },
  actions: {
    api_index (context, data) {
      return new Promise ((resolve, reject) => {
        axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/"), {
          data: {
            http_verb: 'get',
            api_route,
            ...data.params
          }
        }).then(response => {
          if (response.status === 200) {
            context.commit('store_collection', {
              data: response.data,
              meta: {
                pagination: {
                  // descending: false,
                  // page: data.params.page,
                  // sortBy: 'created-at',
                  rowsPerPage: response.headers['per-page'],
                  totalItems: response.headers.total
                }
              }
            })
          }
          resolve (response)
        }, error => {
          reject (error)
        })
      })
    },
    api_show (context, data) {
      return new Promise ((resolve, reject) => {
        axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/"), {
          data: {
            http_verb: 'get',
            api_route: [api_route, data.tenant_account_id].join("/"),
            ...data.params
          }
        }).then(response => {
          if (response.status === 200) {
            context.commit ('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            })
            context.commit ('update_element', response.data.data)
          }
          resolve (response)
        }, error => {
          reject (error)
        })
      })
    },
    api_create (context, data) {
      return new Promise ((resolve, reject) => {
        axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/"), {
          data: {
            http_verb: 'post',
            api_route: [api_route, data.id].join("/"),
            ...data
          },
        }).then(response => {
          if (response.status === 201) {
            context.commit ('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            })
            context.commit ('add_element', response.data.data)
          }
          resolve (response)
        }, error => {
          reject (error)
        })
      })
    },
    api_update (context, data) {
      axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/") , {
        data: {
          http_verb: 'patch',
          api_route: [api_route, data.id].join('/'),
          data: data.data
        }
      }).then(response => {
        if (response.status === 200) {
          context.commit ('store_element', {
            data: response.data.data,
            meta: {
              id: response.data.data.id
            }
          })
          context.commit ('update_element', response.data.data)
        }
      }).catch( error => { 

      })
    },
    api_destroy (context, data) {
      return new Promise ((resolve, reject) => {
        axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/") , {
          data: {
            http_verb: 'delete',
            api_route: [api_route , data.id].join('/'),
          }
        }).then(response => {
          if (response.status < 400) {
            context.commit ('remove_element', data.id)
          }
          resolve (response)
        }, error => {
          reject (error)
        })
      })
    }
  },
  getters: {
    json_collection,
    meta_collection,
    json_element,
    meta_element
  }
}

export default tenant_accounts


// WEBPACK FOOTER //
// ./src/modules/systemStates/store/tenant_accounts.js